import { SceneTemplate } from "@/lib/utils/lomda/types";

export const templateG: SceneTemplate = {
    name: "תבנית ז",
    aspectRatio: "1:1.414",
    branding: {
        background: "primary",
        foreground: {
            color: "secondary",
            circle: true,
            size: {
                width: 134,
                height: 134,
            },
            location: {
                x: -13.8,
                y: -19,
            },
        },
    },
    avatar: {
        size: {
            width: 33,
            height: 73,
        },
        location: {
            x: 67,
            y: 27,
        },
    },
    scene: {
        scale: 88.88,
        rounded: true,
        location: {
            x: 10.41,
            y: 5.56,
        },
    },
};
